import { render } from "./MiezzHsCode.vue?vue&type=template&id=642985a3&scoped=true&ts=true"
import script from "./MiezzHsCode.vue?vue&type=script&lang=ts"
export * from "./MiezzHsCode.vue?vue&type=script&lang=ts"

import "./MiezzHsCode.vue?vue&type=style&index=0&id=642985a3&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642985a3"]])

export default __exports__